
$w.onReady(function () {
    $w('#headerTransitionPoint').onViewportLeave(() => {
        $w('#stickyHeader1').show();
        $w('#stickyHeader2').show();
        $w('#defaultHeader1').hide();
        $w('#defaultHeader2').hide();

    });
});
$w.onReady(function () {
    $w('#headerTransitionPoint').onViewportEnter(() => {
        $w('#stickyHeader1').hide();
        $w('#stickyHeader2').hide();
        $w('#defaultHeader1').show();
        $w('#defaultHeader2').show();
    });

    $w('#headerTransitionPoint').onViewportLeave(() => {
        $w('#stickyHeader1').show();
        $w('#stickyHeader2').show();
        $w('#defaultHeader1').hide();
        $w('#defaultHeader2').hide();
    });
});// The code in this file will load on every page of your site
